import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import RowClick from '../../../../common/RowClick';
import Table from '../../../../common/table/Table';
import TextBlink from '../../../../common/table/TextBlink';
import { getColorPrice } from '../../../../helpers/Color';
import { getDataFollowKeyByDot, getRanking } from '../../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../../helpers/Text';
import CellHover from '../../../../market/watchlist/summary/CellHover';
import '../../../technical.scss';
import { REDUCER_NAME } from '../reducer';
import Const from './Const';
import { I18n } from 'react-redux-i18n';
import TradingViewUrl from '../../../../common/TradingViewUrl';
import { compose } from 'redux';

class TableClosing extends React.PureComponent {
  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectDeceptiveClosingDataByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.REF_PRICE),
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      'text',
    );
  };

  handleScroll = e => {
    const { totalPage, onLoadMore, page } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page >= totalPage) return;
    if (bottom) {
      onLoadMore(page + 1);
    }
  };

  getThTooltip = key => {
    const mapKey = {
      [Const.listColumn.VOLUME_PREVIOUS]: I18n.t('table.technical.volPrev'),
      [Const.listColumn.RANK]: I18n.t('table.technical.ranking'),
    };

    return mapKey[key];
  };

  schema = (listColumn, i18nTitleKey) => {
    return Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          thStyle: { width: '40px' },
          render: (text, item) => (
            <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
              <TextBlink item={item} tradingDate="tradingDate">
                <TradingViewUrl code={item.organCode} />
                &nbsp;{text}
              </TextBlink>
            </CellHover>
          ),
        };
      }

      if (_.includes([listColumn.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [
            listColumn.VOLUME,
            listColumn.VOLUME_AFTER_2PM,
            listColumn.VOLUME_BEFORE_2PM,
            listColumn.AVG_VOLUME_10D,
            listColumn.VOLUME_PREVIOUS,
          ],
          key,
        )
      ) {
        return {
          ...result,
          thTooltip: this.getThTooltip(key),
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatVolume(text))}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.RANK], key)) {
        return {
          ...result,
          thTooltip: this.getThTooltip(key),
          thStyle: { textAlign: 'center', width: 70 },
          render: (text, item) => {
            const total = getDataFollowKeyByDot(
              item,
              Const.listColumn.TOTALRANK,
            );
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {getRanking(text, total)}
              </TextBlink>
            );
          },
        };
      }

      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {formatTextFloat(text, 0)}
          </TextBlink>
        ),
      };
    });
  };

  render() {
    const { isLoading, onSort, ids, scrollRef } = this.props;
    const currentTime = new Date();
    const startTime = new Date(
      currentTime.getFullYear(),
      String(currentTime.getMonth()).padStart(2, '0'),
      String(currentTime.getDate()).padStart(2, '0'),
      Const.startTime,
    );
    const openTime = new Date(
      currentTime.getFullYear(),
      String(currentTime.getMonth()).padStart(2, '0'),
      String(currentTime.getDate()).padStart(2, '0'),
      Const.openTime,
    );
    const isBefore2h = startTime < currentTime && currentTime < openTime;
    if (!isBefore2h) {
      if (ids.length === 0 && !isLoading) {
        return (
          <div className="empty-data-msg text-s-color-3">
            {I18n.t('tasignals.deceptiveDataMessage.noDataForFilter')}
          </div>
        );
      }
    }

    return (
      <RowClick>
        {onRowClick => (
          <Table
            onSort={onSort}
            clickRow={onRowClick}
            thValign="top"
            isLoading={isLoading}
            ids={ids}
            scrollRef={scrollRef}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            onScrollFunction={this.handleScroll}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            isShowHeadLoading={false}
            schema={this.schema(Const.listColumn, 'tasignals.closingHeader')}
            noDataText={
              isBefore2h
                ? I18n.t('tasignals.deceptiveDataMessage.nodataClosing')
                : ''
            }
          />
        )}
      </RowClick>
    );
  }
}
const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listDeceptiveClosingDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TableClosing);
